var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-list", {
    attrs: {
      entity: "lammie",
      "use-events": true,
      "api-name": "lammieRequests",
      "event-id": _vm.eventId,
      "team-id": _vm.teamId
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }